// extracted by mini-css-extract-plugin
export default {"main-body":"MainBody_main-body__4nBpk","disclaimer":"MainBody_disclaimer__ir9be","sins":"MainBody_sins__ORNIa"};